"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpsOriginStatus = exports.DigitalSubmissionType = exports.ComponentValidation = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["EXAMINED"] = "examined";
    ComponentType["MODERATED"] = "moderated";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ComponentValidation;
(function (ComponentValidation) {
    ComponentValidation["ALWAYS_ALLOW"] = "alwaysAllow";
    ComponentValidation["ALL_SECTIONS_UPLOADED"] = "allSectionsUploaded";
    ComponentValidation["AT_LEAST_ONE_SECTION_UPLOADED"] = "atLeastOneSectionUploaded";
})(ComponentValidation = exports.ComponentValidation || (exports.ComponentValidation = {}));
var DigitalSubmissionType;
(function (DigitalSubmissionType) {
    DigitalSubmissionType["WORK"] = "work";
    DigitalSubmissionType["MARKS"] = "marks";
    DigitalSubmissionType["SAMPLES"] = "samples";
})(DigitalSubmissionType = exports.DigitalSubmissionType || (exports.DigitalSubmissionType = {}));
var EpsOriginStatus;
(function (EpsOriginStatus) {
    EpsOriginStatus["NONE"] = "None";
    EpsOriginStatus["SOME"] = "Some";
    EpsOriginStatus["ALL"] = "ALL";
})(EpsOriginStatus = exports.EpsOriginStatus || (exports.EpsOriginStatus = {}));
